'use strict';

export default class UserModificationModalController {
  /*@ngInject*/


  constructor($http, Group, ManageGroup, Auth, $scope, $timeout, $uibModalInstance, editUser, Signup) {
    this.$http = $http;
    this.Group = Group;           //inject as a service
    this.ManageGroup = ManageGroup;
    this.Auth = Auth;
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$timeout = $timeout;
    this.editUser = editUser;
    this.newUser = {};
    this.modifyUser = {};
    this.rename = {};
    this.create = {};
    this.question = {};
    this.questions = {};
    this.Signup = Signup;
    this.phoneVerification = {};
  }

  $onInit() {
    this.group = this.mergeGroup
    this.Auth.getCurrentUser()
      .then((user) => {
        this.user = user;
        this.group = user.group;
      })
      .then(() => {
        // For modification of the user
        if (this.editUser !== undefined) {
          this.modifyUser._id = this.editUser._id
          this.modifyUser.firstName = this.editUser.firstName
          this.modifyUser.lastName = this.editUser.lastName
          this.modifyUser.staffRole = this.editUser.staffRole
        }
      })
  }

  invite = (form) => {
    let data = {};
    this.errors = [];
    this.newUser.success = false;

    if (form.$valid) {
      //Set the data here
      data.email = this.newUser.email;             //Set the data here for post request
      data.firstName = this.newUser.firstName;
      data.lastName = this.newUser.lastName;
      data.staffRole = this.newUser.staffRole;
      data.group = this.group._id;

      this.Group.invitePhysician(data)
        .then(() => {
          this.newUser.success = true;
        })
        .then(() => {
          // Close the Modal on success
          this.$timeout(() => {
            this.$uibModalInstance.close();
          }, 1500);

        })
        .catch(err => {
          console.log('invite -> catch -> ', err)
          if (err.status == 422) {
            //Error message of the email validation
            if (Object.keys(err.data).length !== 0)
              this.errors = [err.data.errors.email.message];
            else
              this.errors = [err.statusText];
          }
          else {
            if (Object.keys(err.data).length !== 0)
              this.errors = [err.data.errors.email.message];
            else
              this.errors = [err.statusText];
          }
        })
    }
  }

  verify = (form) => {
    let data = {};
    this.errors = [];
    this.phoneVerification.success = false;

    if (form.$valid) {
      //Set the data here
      data.code = this.phoneVerification.code;
      // console.log('this.editUser', this.editUser)
      if (this.editUser.id) {
        data.invitedUserId = this.editUser.id
        this.Signup.verify(data)
          .then(() => {
            this.phoneVerification.success = true;
          })
          .then(() => {
            // Close the Modal on success
            this.$timeout(() => {
              this.$uibModalInstance.close();
            }, 1500);

          })
          .catch(err => {
            console.log('verify -> catch -> ', err)
            if (err.data.message)
              this.errors = [err.data.message];
            else
              this.errors = err.data;
          })
      }
      else if (this.editUser.hasOwnProperty('code')) {
        if (this.editUser.code == this.phoneVerification.code) {
          // Close the Modal on success
          this.$timeout(() => {
            this.$uibModalInstance.close();
          }, 1500);
        }
        else
          this.errors = ['Please enter a valid code.']
      }
    }
  }

  edit = (form) => {
    let data = {};
    this.errors = [];
    this.modifyUser.success = false;

    if (form.$valid) {
      //Set the data here
      data._id = this.modifyUser._id;
      data.firstName = this.modifyUser.firstName;
      data.lastName = this.modifyUser.lastName;
      data.staffRole = this.modifyUser.staffRole;

      this.Group.editPhysicians(data)
        .then(() => {
          this.modifyUser.success = true;
        })
        .then(() => {
          //Clear the form
          this.$timeout(() => {
            this.$uibModalInstance.close();
          }, 1500);
        })
        .catch(err => {
          //Error message of the password validation
          this.errors = err.data;
        })
    }
  }

  renameGroup = (form) => {
    this.rename.success = false
    if (form.$valid) {
      let data = {};
      data._id = this.group._id;         //Set the group _id here

      data.name = this.rename.name;             //Set the updated group name here
      this.Group.renameGroup(data)
        .then((response) => {
          this.user.group.name = response.name
        })
        .then(() => {
          this.rename.success = true;
        })
        .then(() => {
          //Clear the form
          this.$timeout(() => {
            this.$uibModalInstance.close();
          }, 1500);
        })
    }
  }

  createGroup = (form) => {
    this.createGroup.success = false;
    this.ManageGroup.createGroup(this.create.name)
      .then((response) => {
        this.createGroup.success = true
      })
      .then(() => {
        //Clear the form
        this.$timeout(() => {
          this.$uibModalInstance.close();
        }, 1500);
      })
  };

  mergeGroup = (form) => {
    let data = {}
    data.mergeFrom = this.editUser._id;
    data.mergeTo = this.mergeTo

    this.mergeGroup.success = false;
    this.ManageGroup.mergeGroup(data)
      .then((response) => {
        this.mergeGroup.success = true;
        this.$timeout(() => {
          this.$uibModalInstance.close();
        }, 1500);
      })
      .catch(err => {
        this.error = err.error
      })
  };

  createQuestion = (res) => {
    this.question.success = false;
    this.question.saveMessage = false;
    let data = [];
    data.name = res.questionName.$viewValue;
    data.group = this.user.group._id
    this.Group.addQuestion(data)
      .then((response) => {
        this.question.success = true
        this.questions = response.data[0]
      })
      .then(() => {
        //Clear the form
        window.location.reload();
      }).catch(err => {
        this.question.saveMessage = true;
        this.errors.submit = err.message;
      });
  }
}



// WEBPACK FOOTER //
// ./client/components/user-modification-modal/user-modification-modal.controller.js